import React, { FC, useRef } from "react";
import { InputNumber as LibraryInputNumber, InputNumberProps } from "antd";

type Props = Omit<InputNumberProps, "onChange"> & {
  onChange?: (value: number) => void;
  currencySymbol: string;
};

export const PriceInput: FC<Props> = ({
  onChange = () => {},
  currencySymbol,
  value,
  ...others
}) => {
  const libraryInputNumberRef = useRef<any>(null);

  return (
    <LibraryInputNumber
      {...others}
      key={`price-input-${currencySymbol}`}
      value={value}
      ref={libraryInputNumberRef}
      onFocus={() => {
        if (libraryInputNumberRef.current) {
          libraryInputNumberRef.current.select();
        }
      }}
      formatter={(value: string | number | undefined) => {
        if (value === undefined || value === "") {
          return "";
        }
        const numericValue = typeof value === "number" ? value : parseFloat(value);
        return `${currencySymbol} ${numericValue.toLocaleString()}`;
      }}
      parser={(v: any) => {
        // Escape the currency symbol.
        const escapedCurrencySymbol = currencySymbol.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
        // If the currency symbol is not empty, include it in the pattern; otherwise, just match commas.
        const pattern = escapedCurrencySymbol ? `${escapedCurrencySymbol}\\s?|,` : ",";
        return v.replace(new RegExp(pattern, "g"), "");
      }}
      onChange={(newValue) => {
        let value = 0;
        if (typeof newValue === "number") {
          value = newValue;
        } else if (typeof newValue === "string") {
          try {
            value = parseFloat(newValue);
          } catch (e) {
            value = 0;
          }
        }
        onChange && onChange(value);
      }}
    />
  );
};
